import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";

class figureList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        let {view, componentConfig, filter, selection, isLoading} = this.props;
        if (this.props.component && this.props.componentId) {
            filter = filter || [];
            if (!Array.isArray(filter)) {
                filter = [filter];
            }
            filter.push({field: "component", value: this.props.component});
            filter.push({field: "component_id", value: this.props.componentId});
        }
        const props = {componentConfig, filter, loading: isLoading, pageSize: this.props.pageSize !== undefined ? this.props.pageSize : 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "figureList"}
                {...props}
                columns={{
                    "id": {header: 'Kód', width: 3, sortable, filterable},
                    "path": {header: 'Útvonal', width: 3, sortable, filterable},
                    "name": {header: 'Név', width: 3, sortable, filterable},
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default figureList;
